<template>
	<div>
		<label
			:ref="labelRef"
			:for="labelFor"
			:aria-disabled="isLoadingImage"
		>
			<vue-six-four
				:id="labelFor"
				hidden
				@vue-six-four="getFile"
			/>
			<div>
				<label class="caption block" v-if="!!textLabel">{{ textLabel }}</label>
				<input
					readonly
					style="width: 500px"
					class="form-input input-upload"
					:class="{ 'form-input-full' : !visibleMore }"
					:aria-label="textLabel"
					v-bind="$attrs"
					:disabled="isLoadingImage"
					:value="urlImage"
				/>
				<button
					type="button"
					class="btn-action"
					@click="actionUploadImage"
					:disabled="isLoadingImage"
				>
					<img :src="`/static/img/${icon}.svg`" alt="Subir imagen" height="26px" width="32px">
				</button>
				<button
					id="btnDelete"
					style="margin-left: 0px"
					type="button"
					class="btn-action"
					@click="actionDeleteImage"
					:disabled="isLoadingImage"
				>
					<img :src="`/static/img/${iconDelete}.svg`" alt="Borrar imagen" height="26px" width="32px">
				</button>
				<button
					class="btn-plus"
					type="button"
					@click="$emit('add-image')"
					v-if="visibleMore"
					:disabled="isLoadingImage"
				>
					<img src="/static/img/icon-plus.svg" alt="Subir imagen" height="20px" width="20px">
				</button>
				<span v-show="isLoadingImage">
					Cargando...
				</span> 
			</div>
		</label>
	</div>
</template>

<script>
	import VueSixFour from 'vue-six-four';

	function actionUploadImage() {
		this.$refs[this.labelRef].click();
	}

	function actionDeleteImage() {
		this.$emit('delete-image', 'delete');
	}

	async function deleteFile(fileInfo) {
		try {
			this.$emit('delete-image', fileInfo);
		} catch (error) {
			this.showError();
			this.isLoadingImage = false;
		}
	}

	async function getFile(fileInfo) {
		this.isLoadingImage = true;
		const newFile = {
			name: fileInfo.name.replace(/\s/g, '-'),
			type: fileInfo.type,
			file: fileInfo.sixFour,
		};
		try {
			const words = newFile.name.split('.');
			const lastItem = words.length;
			const extension = words[lastItem - 1];
			if (this.allowedFiles.indexOf(extension) > -1) {
				const { data: response } = await this.$http.post('file/one-upload', newFile);
				const newImage = new Image();
				if (this.fileType === 'urlFile') {
					this.$emit('send-image', response.data[this.fileType]);
					this.isLoadingImage = false;
				} else {
					newImage.onload = () => {
						this.$emit('send-image', response.data[this.fileType]);
						this.isLoadingImage = false;
					};
				}
				newImage.src = response.data[this.fileType];
			} else {
				this.showNotification(`Archivo no válido, solo se permite ${this.allowedFiles.join(',')}`);
				this.isLoadingImage = false;
			}
		} catch (error) {
			this.showError();
			this.isLoadingImage = false;
		}
	}

	function data() {
		return {
			allowedFiles: ['jpg', 'jpeg', 'png', 'svg', 'pdf', 'mp4', 'mpg', 'avi', 'mov'],
			allowedMaxSize: 25,
			isLoadingImage: false,
			newImage: '',
		};
	}

	export default {
		name: 'upload-image',
		inheritAttrs: false,
		components: {
			VueSixFour,
		},
		data,
		methods: {
			actionUploadImage,
			actionDeleteImage,
			getFile,
			deleteFile,
		},
		props: {
			fileType: {
				default: 'urlImage',
				type: String,
			},
			labelFor: [Number, String],
			labelRef: [Number, String],
			urlImage: [String, Array],
			visibleMore: {
				type: Boolean,
				default: true,
			},
			textLabel: {
				type: String,
				default: 'Adjuntar Foto',
			},
			icon: {
				type: String,
				default: 'camera-icon',
			},
			iconDelete: {
				type: String,
				default: 'icon-close',
			},
		},
	};
</script>

<style lang="scss" scoped>
	.block {
		display: block;
	}

	.btn-action {
		background-color: map-get($colors, black-dark);
		border-bottom-right-radius: 4px;
		border-top-right-radius: 4px;
		height: 48px;
		margin-left: 0;
		margin-top: 0;
		vertical-align: top;
		
		img {
			vertical-align: bottom;
		}
	}

	.btn-plus {
		background-color: map-get($colors, black-dark);
		border-radius: 4px;
		height: 30px;
		margin-left: 15px;
		padding: 5px 0px;
		vertical-align: sub;
		width: 30px;
	}

	.caption {
		font-size: 12px;
	}
	
	.form-input {
		border-radius: 4px;
		outline: 0;
		padding-right: 45px;
		width: calc(100% - 56px);

		&-full {
			width: calc(100% - 5px);
		}
	}

	.input-upload {
		border: 1px solid map-get($colors, border-input);
	}
</style>



// WEBPACK FOOTER //
// src/components/commons/upload-image.vue